var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 15C0.25 17.6234 2.37665 19.75 5 19.75L15 19.75C17.6234 19.75 19.75 17.6234 19.75 15L19.75 11C19.75 8.37665 17.6234 6.25 15 6.25L14.5 6.25C14.0858 6.25 13.75 6.58579 13.75 7C13.75 7.41421 14.0858 7.75 14.5 7.75L15 7.75C16.7949 7.75 18.25 9.20507 18.25 11L18.25 15C18.25 16.7949 16.7949 18.25 15 18.25L5 18.25C3.20507 18.25 1.75 16.7949 1.75 15L1.75 11C1.75 9.20507 3.20507 7.75 5 7.75L5.5 7.75C5.91421 7.75 6.25 7.41421 6.25 7C6.25 6.58579 5.91421 6.25 5.5 6.25L5 6.25C2.37665 6.25 0.25 8.37665 0.25 11L0.25 15ZM6.46967 3.46967C6.17678 3.76256 6.17678 4.23744 6.46967 4.53033C6.76256 4.82322 7.23744 4.82322 7.53033 4.53033L9.25 2.81066L9.25 13C9.25 13.4142 9.58579 13.75 10 13.75C10.4142 13.75 10.75 13.4142 10.75 13L10.75 2.81066L12.4697 4.53033C12.7626 4.82322 13.2374 4.82322 13.5303 4.53033C13.8232 4.23744 13.8232 3.76256 13.5303 3.46967L10.5303 0.469669C10.2374 0.176776 9.76256 0.176776 9.46967 0.469669L6.46967 3.46967Z",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadResume);
export default __webpack_public_path__ + "static/media/upload-resume.9a789739.svg";
export { ForwardRef as ReactComponent };